import React from "react"
import {useTranslation} from "react-i18next"
import {useSnackbar} from "notistack"
import Typography from "@mui/material/Typography"
import {useTheme} from "@mui/material"

// @ts-ignore
import FormSmallContainer from "../../../../../../../components/FormSmallContainer"
// @ts-ignore
import Container from "../../../../../../../components/Container"
import {
  notifyForTmApprove,
  submitTmApprove,
  uploadTicketReviewProcessFiles,
  uploadTicketReviewProcessSignature
} from "../../../../../../../api/ticketReviewProcess"
import SignatureAndTextFieldForm, {
  SignatureAndTextFieldFormValues
} from "../../../../../../../forms/SignatureAndTextFieldForm"
import {hasFilesForUpload} from "../../../../../../../util/file"
import {useTracFloSelector} from '../../../../../../../store/useTracFloSelector'
import {stringIsValidNonWhitespace} from '../../../../../../../util/string'


interface TmApproveFormProps {
  toggleFormOpen: () => void,
  ticketId: string,
  projectId: string,
  ticketActionChange: (new_action_id: number) => void
}

export default function TmApproveForm(props: TmApproveFormProps) {
  const project = useTracFloSelector((s) => s.project)
  const { t } = useTranslation("private")
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const theme = useTheme()

  const submitForm = async (values: SignatureAndTextFieldFormValues): Promise<void> => {
    try {
      // update the ticket status
      const {data: trp} = await submitTmApprove(
        props.ticketId,
        props.projectId,
        values.message.length === 0 ? null : values.message
      )
      // upload files
      if (hasFilesForUpload(values.files)) {
        const uploadingKey = enqueueSnackbar('Uploading files...', {variant: 'info'})
        const fileUploadMessage = await uploadTicketReviewProcessFiles(values.files, props.projectId, trp.id)
        closeSnackbar(uploadingKey)
        enqueueSnackbar(
          fileUploadMessage.message,
          {
            variant: fileUploadMessage.error ? 'error' : 'success',
            style: {whiteSpace: 'pre-wrap'}
          }
        )
      }
      // upload signature
      const signatureUploadMessage = await uploadTicketReviewProcessSignature(values.signature, props.projectId, trp.id)
      if (signatureUploadMessage.error) {
        enqueueSnackbar(signatureUploadMessage.message, {variant: 'error', style: {whiteSpace: 'pre-wrap'}})
      }
      // notify of the approval and create history object
      await notifyForTmApprove(trp.id, props.projectId)
      props.toggleFormOpen()
      if (trp?.new_action_id) {
        props.ticketActionChange(trp.new_action_id)
      }
      enqueueSnackbar(t('view.Tickets.tm_approve_success'), {variant: "success"})
    } catch (_) {
      enqueueSnackbar(t('view.Tickets.tm_approve_fail'), {variant: "error"})
    }
  }

  return (
    <FormSmallContainer>
      {// only show the disclaimer box if we have a disclaimer to show
        stringIsValidNonWhitespace(project.disclaimer)
          ? <Container
            style={{
              background: theme.palette.grey[600],
              marginBottom: theme.spacing(6),
              marginTop: -theme.spacing(6),
              padding: theme.spacing(4),
            }}
          >
            <Typography variant="h3" align={"center"} style={{ color: "white", textTransform: 'uppercase' }}>
              {project.disclaimer}
            </Typography>
          </Container>
          : <></>
      }
      <SignatureAndTextFieldForm
        submitValues={submitForm}
        formCancel={props.toggleFormOpen}
        titleText={t('view.Tickets.tm_approve_title')}
      />
    </FormSmallContainer>
  )
}
